// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__Y6LF4","Accordion_title":"Accordion_Accordion_title__pqrWI"};